<kendo-grid
  class="grid"
  [data]="ruleWrappers"
  (cellClick)="cellClick($event)"
  (cellClose)="cellClose($event)"
  (save)="saveNew($event)"
  (remove)="remove($event)"
  (cancel)="cancel($event)"
  [resizable]="true">
  <ng-template kendoGridToolbarTemplate position="top" let-position="position">
    <div class="toolbar">
      <button
        kendoButton
        (click)="addNotification()"
        themeColor="primary"
        class="toolbar-button">
        <div class="toolbar-button-content">
          <span class="k-icon k-font-icon k-i-plus"></span>
          <span>Add</span>
        </div>
      </button>
    </div>
  </ng-template>

  <kendo-grid-column
    field="name"
    title="Name"
    [width]="350"></kendo-grid-column>

  <kendo-grid-column field="clientIds" title="Clients">
    <ng-template kendoGridCellTemplate let-dataItem>
      <div class="edit-list">
        {{ displayClients(dataItem.clients) }}
      </div>
    </ng-template>
    <ng-template
      kendoGridEditTemplate
      let-dataItem="dataItem"
      let-formGroup="formGroup">
      <div class="edit-empty-list">
        @if (notificationRuleToAdd?.clients?.length) {
          <div>
            {{ displayClients(notificationRuleToAdd.clients) }}
          </div>
        } @else {
          <span>Click to edit</span>
          &nbsp;
          <span class="k-icon k-font-icon k-i-pencil"></span>
        }
      </div>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="processNodeIds" title="Processes">
    <ng-template kendoGridCellTemplate let-dataItem>
      <div class="edit-list">
        {{ displayProcessNodes(dataItem.processNodes) }}
      </div>
    </ng-template>
    <ng-template
      kendoGridEditTemplate
      let-dataItem="dataItem"
      let-formGroup="formGroup">
      <div class="edit-empty-list">
        @if (notificationRuleToAdd?.processNodes?.length) {
          <div>
            {{ displayProcessNodes(notificationRuleToAdd.processNodes) }}
          </div>
        } @else {
          <span>Click to edit</span>
          &nbsp;
          <span class="k-icon k-font-icon k-i-pencil"></span>
        }
      </div>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="statuses" title="Statuses" [width]="150">
    <ng-template kendoGridCellTemplate let-dataItem>
      {{ displayStatuses(dataItem.statuses) }}
    </ng-template>
    <ng-template
      kendoGridEditTemplate
      let-dataItem="dataItem"
      let-formGroup="formGroup">
      <kendo-multiselect
        [data]="statuses"
        [valuePrimitive]="true"
        [formControl]="formGroup.get('statuses')"
        [textField]="'name'"
        [valueField]="'value'"
        [autoClose]="false"
        (valueChange)="
          onStatusesValueChange(dataItem, $event)
        "></kendo-multiselect>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column title="Actions" [width]="100">
    <ng-template kendoGridCellTemplate let-isNew="isNew" let-dataItem>
      @if (canUpdate(isNew, dataItem)) {
        <button
          class="btn btn-light btn-icon btn-sm action-btn"
          (click)="save(dataItem)">
          <span class="freshicon freshicon-save freshicon-sm"></span>
        </button>
      }
      <button
        kendoGridRemoveCommand
        class="btn btn-light btn-icon btn-sm action-btn">
        <span class="freshicon freshicon-delete freshicon-sm"></span>
      </button>
      <button
        kendoGridSaveCommand
        class="btn btn-light btn-icon btn-sm action-btn">
        <span class="freshicon freshicon-save freshicon-sm"></span>
      </button>
      <button
        kendoGridCancelCommand
        class="btn btn-light btn-icon btn-sm action-btn">
        <span class="freshicon freshicon-cancel freshicon-sm"></span>
      </button>
    </ng-template>
  </kendo-grid-column>

  <ng-template kendoGridNoRecordsTemplate>No data</ng-template>
</kendo-grid>
